module.exports = __webpack_public_path__ + "media/application/images/icons/dropdown-arrow-360468e933ef9d1ffb50876f358805ae.svg";